import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
  
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "./Title";
import { BotonAuditar } from "./BotonAuditar";
import { cleanSolicitudes, getSolicitudesTomadasPorUsuario } from "../actions/autorizaciones/Autorizaciones";
import { TIPOS_AUTORIZACIONES } from "../utils/constants";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export default function IndicadorAutorizaciones(...props) {
  const dispatch = useDispatch();
  const { detalleSolicitudes } = useSelector( (state) => state.indicadores );

  useEffect(() => {
      dispatch( cleanSolicitudes() );
      dispatch( getSolicitudesTomadasPorUsuario() );
  }, [dispatch]);
  
  return (
    <>
      <Title>Estado de internación / Seguimiento de casos</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Efector</TableCell>
            <TableCell>Seccional</TableCell>
            <TableCell>N° Solicitud</TableCell>
            <TableCell>Tipo Solicitud</TableCell>
            <TableCell>Afiliado</TableCell>
            <TableCell>Diagnostico</TableCell>
            <TableCell>Tomada por</TableCell>
            <TableCell>Fecha Seguimiento</TableCell>
            <TableCell>Observación Seguimiento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detalleSolicitudes.map((row, i) => (
            <TableRow key={i}>
              <TableCell> 
                {row.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA
                  ? row.efectorInstitucional
                  : row.efectorFactNombreFantasia
                }
              </TableCell>
              <TableCell>{row.seccional}</TableCell>
              <TableCell>{row.nroSolicitud}</TableCell>
              <TableCell>{row.tipoSolicitud}</TableCell>
              <TableCell>{row.afiliado}</TableCell>
              <TableCell>{row.diagnostico}</TableCell>
              <TableCell>{row.tomadaPor}</TableCell>
              <TableCell>
                {new Date(row.fechaSeguimiento).toLocaleString("es", optionsfecha)}
              </TableCell>
              <TableCell>{row.observacionSeguimiento}</TableCell>
              <TableCell>
                <BotonAuditar 
                  detalleSolicitud={row} 
                  {...props}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}